"use client";

import Link from "next/link";
import Image from "next/image";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import {
  APP_STATE_STORAGE_EVENT,
  getStoredState,
} from "@/services/stateStorage";

const menuItems = [
  {
    label: "Seu Perfil",
    icon: "/icons/menu/profile.svg",
    href: "/cadastro",
    hash: "",
  },
  {
    label: "Mapa",
    icon: "/icons/menu/map.svg",
    href: "/mapa",
    hash: "#mapa",
  },
  {
    label: "QR Code",
    icon: "/icons/menu/qrcode.svg",
    href: "/qrcode",
    hash: "qrcode",
  },
  {
    label: "FAQ",
    icon: "/icons/menu/faq.svg",
    href: "/faq",
    hash: "#faq",
  },
  // {
  //   label: "Últimas Notícias",
  //   icon: "/icons/menu/notification.svg",
  //   href: "/home#ingressos",
  //   hash: "#noticias",
  // },
];

export default function BottomMenu() {
  const pathname = usePathname();
  const [currentHash, setCurrentHash] = useState("");
  const [stateCode, setStateCode] = useState(getStoredState);

  useEffect(() => {
    const syncHash = () => {
      setCurrentHash(window.location.hash);
    };

    syncHash();
    window.addEventListener("hashchange", syncHash);

    return () => {
      window.removeEventListener("hashchange", syncHash);
    };
  }, []);

  useEffect(() => {
    const syncState = () => {
      setStateCode(getStoredState());
    };

    syncState();
    window.addEventListener("storage", syncState);
    window.addEventListener(APP_STATE_STORAGE_EVENT, syncState);
    window.addEventListener("focus", syncState);
    window.addEventListener("visibilitychange", syncState);

    return () => {
      window.removeEventListener("storage", syncState);
      window.removeEventListener(APP_STATE_STORAGE_EVENT, syncState);
      window.removeEventListener("focus", syncState);
      window.removeEventListener("visibilitychange", syncState);
    };
  }, []);

  const visibleMenuItems = menuItems.filter(
    (item) => !(stateCode === "RJ" && item.href === "/qrcode"),
  );

  return (
    <nav
      aria-label="Menu inferior"
      className="fixed inset-x-0 bottom-0 z-40 bg-[#FEC822] px-3 pt-4 pb-[calc(env(safe-area-inset-bottom)+12px)]"
    >
      <div
        className={`mx-auto grid w-full max-w-5xl gap-2 ${
          visibleMenuItems.length === 3 ? "grid-cols-3" : "grid-cols-4"
        }`}
      >
        {visibleMenuItems.map((item, index) => {
          const itemPath = item.href.split("#")[0];
          const isCurrentRoute = pathname === itemPath;
          const isActive =
            item.hash && isCurrentRoute
              ? currentHash === item.hash || pathname === itemPath
              : isCurrentRoute;

          return (
            <Link
              key={index}
              href={item.href}
              className="flex min-w-0 flex-col items-center justify-start gap-3 text-center"
            >
              <div
                className={`flex h-[42px] w-[42px] items-center justify-center rounded-full bg-[#2033EF] transition-transform duration-200 ${
                  isActive ? "scale-100" : "hover:-translate-y-0.5"
                }`}
              >
                <Image
                  src={item.icon}
                  alt=""
                  width={18}
                  height={18}
                  className="h-auto w-auto max-h-[20px] max-w-[32px]"
                />
              </div>

              <span className="text-[12px] font-extrabold leading-[1.05] text-[#2033EF] md:text-[16px]">
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
